import { render, staticRenderFns } from "./placement-strategy-set-info.vue?vue&type=template&id=23fd4461&scoped=true&"
import script from "./placement-strategy-set-info.vue?vue&type=script&lang=js&"
export * from "./placement-strategy-set-info.vue?vue&type=script&lang=js&"
import style0 from "./placement-strategy-set-info.vue?vue&type=style&index=0&id=23fd4461&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fd4461",
  null
  
)

export default component.exports